const useAccordion = (containerParam, summary, body, animationDuration = 250) => {
  const container = containerParam

  // Store the animation object (so we can cancel it if needed)
  let animation = null
  // Store if the element is expanding
  let isExpanding = false
  // Store if the element is closing
  let isClosing = false

  const onAnimationFinish = (open) => {
    // Set the open attribute based on the parameter
    container.current.open = open
    // Clear the stored animation
    animation = null
    // Reset isExpanding & isClosing
    isExpanding = false
    isClosing = false
    // Remove the overflow hidden and the fixed height
    container.current.style.height = ""
    container.current.style.overflow = ""
  }

  const expand = () => {
    // Set the element as "being expanding"
    isExpanding = true

    const startHeight = summary.current.offsetHeight
    const endHeight = summary.current.offsetHeight + body.current.offsetHeight

    // If there is already an animation running
    if (animation) {
      // Cancel the current animation
      animation.cancel()
    }

    // Start animation
    animation = container.current.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [`${startHeight}px`, `${endHeight}px`],
      },
      {
        duration: animationDuration,
        easing: "linear",
      },
    )
    // When the animation is complete, call onAnimationFinish()
    animation.onfinish = () => onAnimationFinish(true)
    // If the animation is cancelled, isExpanding variable is set to false
    animation.oncancel = () => (isExpanding = false)
  }

  const shrink = () => {
    // Set the element as "being closed"
    isClosing = true

    const startHeight = summary.current.offsetHeight + body.current.offsetHeight
    const endHeight = summary.current.offsetHeight

    // If there is already an animation running
    if (animation) {
      // Cancel the current animation
      animation.cancel()
    }

    // Start animation
    animation = container.current.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [`${startHeight}px`, `${endHeight}px`],
      },
      {
        duration: animationDuration,
        easing: "linear",
      },
    )

    // When the animation is complete, call onAnimationFinish()
    animation.onfinish = () => onAnimationFinish(false)
    // If the animation is cancelled, isClosing variable is set to false
    animation.oncancel = () => (isClosing = false)
  }

  const open = () => {
    // Apply a fixed height on the element
    container.current.style.height = `${container.current.offsetHeight}px`
    // Force the [open] attribute on the container element
    container.current.open = true
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => expand())
  }

  return {
    onClick: () => {
      // Add an overflow on the <container> to avoid  body overflowing
      container.current.style.overflow = "hidden"
      // Check if the element is being closed or is already closed
      if (isClosing || !container.current.open) {
        open()
        // Check if the element is being openned or is already open
      } else if (isExpanding || container.current.open) {
        shrink()
      }
    },
  }
}

export default useAccordion
